module.exports = "/images/vendor/desiigner-svg/svg/places/dunes.svg?aacf1f47c94bc105491adeab5dec207c";